<template>
  <template v-if="hasMobileAndDesktopLayouts">
    <template v-if="mq.mdPlus">
      <component
        :is="component(item)"
        v-for="(item, index) in article.desktop"
        :key="index"
        v-bind="item.props"
        :style="item.style"
      >
        <template v-for="(slot, key) in slotContent(item)" #[key] :key="key">
          <SlotElement
            v-for="(element, elementIndex) in slot"
            :key="elementIndex"
            :element="element"
          />
        </template>
      </component>
    </template>

    <template v-else>
      <component
        :is="component(item)"
        v-for="(item, index) in article.mobile"
        :key="index"
        v-bind="item.props"
        :style="item.style"
      >
        <template v-for="(slot, key) in slotContent(item)" #[key] :key="key">
          <SlotElement
            v-for="(element, elementIndex) in slot"
            :key="elementIndex"
            :element="element"
          />
        </template>
      </component>
    </template>
  </template>
  <template v-else>
    <component
      :is="component(item)"
      v-for="(item, index) in article.content"
      :key="index"
      v-bind="item.props"
      :style="item.style"
    >
      <template v-for="(slot, key) in slotContent(item)" #[key] :key="key">
        <SlotElement
          v-for="(element, elementIndex) in slot"
          :key="elementIndex"
          :element="element"
        />
      </template>
    </component>
  </template>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { loadContentJson } from "@/helpers/content.js";
import SlotElement from "@/components/SlotElement.vue";

export default {
  name: "Headless",
  components: {
    SlotElement,
  },
  inject: ["mq"],
  props: {
    articleHandle: {
      type: String,
      required: true,
    },
  },
  computed: {
    article() {
      return loadContentJson(this.articleHandle);
    },
    hasMobileAndDesktopLayouts() {
      return (
        Object.prototype.hasOwnProperty.call(this.article, "mobile") &&
        Object.prototype.hasOwnProperty.call(this.article, "desktop")
      );
    },
  },
  methods: {
    component(content) {
      if (content.tag) {
        return content.tag;
      }

      return defineAsyncComponent(() =>
        import(
          /* webpackChunkName: "[request]" */ `@/components/${content.component}.vue`
        )
      );
    },
    slotContent(item) {
      return item.slot;
    },
  },
};
</script>
